export const PAINEL_ICON_BTN_CLASS =
  "inline-flex size-9 shrink-0 items-center justify-center rounded-md";

export const PAINEL_ICON_SIZE = 18;
